





















































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { GapMeasureFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    VueSelect,
  },
  computed: mapState("gaps", ["measureTypes"]),
})
export default class MeasureFilter extends Vue {
  id = "measure-filter-popover";
  target = "measure-filter-target";
  filter = this.defaultFilter();
  measures = Array<any>();
  defaultFilter(): GapMeasureFilter {
    return {
      typeId: "",
      list: [],
    };
  }
  checkMeasures() {
    this.measures.forEach((m) => {
      m.checked = true;
    });
  }
  uncheckMeasures() {
    this.measures.forEach((m) => {
      m.checked = false;
    });
  }
  search() {
    this.filter.list = this.checkedMeasures;
    const filter = JSON.parse(JSON.stringify(this.filter));
    this.$store.commit("gaps/SET_MEASURE_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.uncheckMeasures();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  get filteredMeasures(): Array<any> {
    if (this.filter.typeId) {
      return this.measures.filter((m) => m.type === this.filter.typeId);
    }
    return this.measures;
  }
  get checkedMeasures(): Array<any> {
    return this.filteredMeasures
      .filter((m) => {
        return m.checked;
      })
      .map((m) => m.id);
  }
  mounted() {
    const filter: GapMeasureFilter = this.$store.state.gaps.filter.measure;
    this.filter.typeId = filter.typeId;
    this.measures = JSON.parse(
      JSON.stringify(this.$store.state.gaps.measures)
    ).map((m) => {
      m.checked = filter.list.includes(m.id);
      return m;
    });
  }
}
